import { render, staticRenderFns } from "./InputElement.vue?vue&type=template&id=6bae06e8&scoped=true&"
import script from "./InputElement.vue?vue&type=script&lang=js&"
export * from "./InputElement.vue?vue&type=script&lang=js&"
import style0 from "./InputElement.vue?vue&type=style&index=0&id=6bae06e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bae06e8",
  null
  
)

export default component.exports